module.exports = __webpack_public_path__ + "img/association015.1a5cf0ba.png";